import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Btn, Input, Field } from "@/components/ui-kit";
import { AuthShell, Notice } from "@/components/AuthShell";
import { ROLE_LABELS } from "@/lib/constants";
import { toast } from "sonner";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { startSession } = useAuth();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [err, setErr] = useState(token ? null : "This invite link is missing its token.");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => setInvite(r.data)).catch((e) => setErr(apiError(e.response?.data?.detail)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token, password: pw });
      await startSession(data);
      toast.success(`Welcome, ${data.user.full_name}`);
      navigate("/");
    } catch (e2) {
      toast.error(apiError(e2.response?.data?.detail));
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Set Up Your Account" subtitle={invite ? `${invite.full_name} · ${invite.email} · ${ROLE_LABELS[invite.role]}` : "Accept your invite"}>
      {err ? (
        <Notice tone="err" data-testid="invite-error">{err}</Notice>
      ) : !invite ? (
        <div className="text-sm text-muted-foreground" data-testid="invite-loading">Checking invite…</div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <Field label="Choose Password (min 8)" required>
            <Input data-testid="invite-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} />
          </Field>
          <Field label="Confirm Password" required>
            <Input data-testid="invite-password-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={8} />
          </Field>
          <Btn type="submit" size="lg" className="w-full" disabled={busy} data-testid="invite-submit">
            {busy ? "Setting up…" : "Create account & sign in"}
          </Btn>
        </form>
      )}
    </AuthShell>
  );
}
